export const state = {
    recipients: {
        data: [],
        total: 0,
        query_total: 0,
    },
    per_page: 50,
}; 